<template>
<div class="chapter">
<div class="inner_page">
<div class="pn">Part One</div>
<div class="pt">London</div>
<div class="pt1">Twenty-Two Years Later</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part_001.vue?fb062c60